import ApiService from "@/common/api.service";
import {
  FETCH_CARRIERS,
  REQUEST_BUY,
  FETCH_BUYS,
  PAY_DEBT,
  FETCH_ADMINBUYS
} from "../actions.type";
import { SET_CARRIERS, SET_BUYS, SET_ADMINBUYS } from "../mutations.type";

const state = {
  carriers: [],
  requestBuy: "",
  buys: [],
  adminBuys: []
};

const getters = {
  carriers(state) {
    return state.carriers;
  },

  buys(state) {
    return state.buys;
  },

  adminBuys(state) {
    return state.adminBuys;
  }
};

const mutations = {
  [SET_CARRIERS](context, newCarriers) {
    state.carriers = newCarriers;
  },

  [SET_BUYS](context, buys) {
    state.buys = buys;
  },

  [SET_ADMINBUYS](context, adminBuys) {
    state.adminBuys = adminBuys;
  }
};

const actions = {
  [FETCH_CARRIERS](context, reload = false) {
    if (state.carriers.length > 0 && !reload)
      return Promise.resolve(context.carriers);

    return ApiService.get("carriers/list").then(carriers => {
      context.commit(SET_CARRIERS, carriers);
      return Promise.resolve(carriers);
    });
  },

  [REQUEST_BUY](context, data) {
    return ApiService.post("buys/request", data);
  },

  [PAY_DEBT](context, data) {
    return ApiService.post("buys/pay/" + data.debtId, data);
  },

  [FETCH_BUYS](context, filters) {
    return ApiService.post("buys/list", filters).then(buys => {
      context.commit(SET_BUYS, buys);
      return Promise.resolve(buys);
    });
  },

  [FETCH_ADMINBUYS](context, filters) {
    return ApiService.post("/admin/buys/list", filters).then(adminBuys => {
      context.commit(SET_ADMINBUYS, adminBuys);
      return Promise.resolve(adminBuys);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
